/**
 * Checks if a date falls within a given range (inclusive)
 * @param date - The date to check (ISO string or Date object)
 * @param rangeStart - Start of the range (ISO string or Date object)
 * @param rangeEnd - End of the range (ISO string or Date object)
 * @returns true if the date is within the range
 */
export const isDateInRange = (
  date: string | Date,
  rangeStart: string | Date,
  rangeEnd: string | Date,
): boolean => {
  const dateTime = new Date(date).getTime();
  const startTime = new Date(rangeStart).getTime();
  const endTime = new Date(rangeEnd).getTime();

  if (Number.isNaN(dateTime) || Number.isNaN(startTime) || Number.isNaN(endTime)) {
    return false;
  }

  return dateTime >= startTime && dateTime <= endTime;
};

/**
 * Checks if two date ranges overlap
 * @param range1Start - Start of the first range
 * @param range1End - End of the first range
 * @param range2Start - Start of the second range
 * @param range2End - End of the second range
 * @returns true if the ranges overlap
 */
export const doDateRangesOverlap = (
  range1Start: string | Date,
  range1End: string | Date,
  range2Start: string | Date,
  range2End: string | Date,
): boolean => {
  const start1 = new Date(range1Start).getTime();
  const end1 = new Date(range1End).getTime();
  const start2 = new Date(range2Start).getTime();
  const end2 = new Date(range2End).getTime();

  if (Number.isNaN(start1) || Number.isNaN(end1) || Number.isNaN(start2) || Number.isNaN(end2)) {
    return false;
  }

  return start1 <= end2 && end1 >= start2;
};
